import React, { useContext, useEffect, useState } from "react";

import Layout from "../screen/Layout/HomeLayout";
import HomeLayout from "../screen/Layout/HomeLayout";
import { UserContext } from "../context/User";
import { TYPE } from "../utility/maroneDefine";
import { useLocation } from "react-router-dom";
import {
  get_userInfoForDevice,
  login,
  update_userdevice,
} from "../service/UserService";

import PrevLayout from "../screen/Layout/PrevLayout";
import Investigatecontainer from "../container/Seekcontainer";
import Seekcontainer from "../container/Seekcontainer";

const Seekpage = () => {
  const { user, dispatch2 } = useContext(UserContext);

    useEffect(() => {
    
      
    }, []);
  
  return (
    <PrevLayout menu={true} bottom={false} header={false} headerdetail={false}>
      <Seekcontainer />
    </PrevLayout>
  );
};

export default Seekpage;
